<template>
    <div>
        <!-- smm abroad-->
        <div :class="['top-header',isScrollTop ? '':'bottom-shadow']" data-spm="nav">
            <header class="header__l" >
                <a v-if="isSohuRefer" class="back-home" href="/" @click.prevent="clickSohuBar()" >
                    <i class="back"></i>
                    <span class="divide-line"></span>
                </a>
                <a class="back-home" href="/">
                    <cite class="sohu"></cite>
                    <p class="sohu-font">首页</p>
                </a>
            </header>
            <div v-show="isShowIcon" class="navbar-icon">
                <div v-if="weatherData.weather" class="wather-sec">
                    <a class="weather-text" :href="weatherData.url" target="_blank" data-spm-data="weathericon">{{weatherData.weather}}&nbsp;/&nbsp;{{weatherData.temperature}}</a>
                </div>
                <span class="divide-line"></span>
                <i class="icon-ic_unfold" @click="changeMoreNavStatus({status:true})"></i>
                <i class="dot" v-show="showDot"></i>
            </div>
            <!-- 使用dom操作去处理，内部会计算高宽 -->
            <div :class="['promotion-box', isScrollTop ? 'visible' : 'hidden']">
                <topRightSlide></topRightSlide>
            </div>
        </div>
        <!-- 按需加载全站导航 -->
        <div v-if="isLayerShow">
            <nav-layer spm-a-b="smwp.content" @cancel="closeLayer" :config="navMap"></nav-layer>
        </div>
        <MoreNav @close="changeMoreNavStatus" v-if="showMoreNav"/>
    </div>
</template>
<script>
    import Util from '../../utils/util.js';
    import Cookie from '../../utils/cookie.js';
    import LocalStorageUtil from '../../utils/localstorageUtil.js'
    import topRightSlide from '../top-right-slide.vue';
    import MoreNav from '../common/more-nav.vue';
    import { getOdinResourceIdMap } from "@/config/odinResourceIds"
    import { getOdinData } from '@/js/request/odinRequest'

    const weatherApi = '//v2.sohu.com/weather-location/weather/weatherdata'
    export default {
        props: [],
        data () {
            return {
                isLayerShow: false,
                isScrollTop: true,
                isSohuRefer: true,
                isShowIcon: false,
                isNavClicked: false,
                weatherKey: 'SOHU_WEATHER',
                weatherStationId: undefined,
                weatherLink: Util.isTestEnvironment() ? '//test.weather.sohu.com/' : '//weather.sohu.com',
                weatherData: {},
                navMap: {}, // 全站导航数据
                showDot: false, // 是否展示红点
                showMoreNav: false, // 是否展示更多组件
            }
        },
        components:{
            topRightSlide,
            MoreNav
        },
        created () {
            this.init()
        },
        beforeMount(){
            this.navMapFetch()
        },
        mounted () {
            this.weatherApiFetch()
            this.showDot = this.hasNavChanged()
            const expireTime = 24*60*60*1000 // 24小时后过期
            LocalStorageUtil.setItem('navMap',this.navMap,expireTime) // 刷新过期时间
            if (window.slhHeight !== undefined) {
                const navHeight = document.querySelector('.top-header').offsetHeight
                document.querySelector('.top-header').style.top = slhHeight + 'px'
                document.querySelector('.article-page').style.paddingTop = window.slhHeight + navHeight + 'px'
            }
        },
        methods: {
            init () {
                const refer = document.referrer.split('?')[0]
                this.isSohuRefer = /.sohu.com/.test(refer)
                this.isNavClicked = LocalStorageUtil.getItem(`navClicked_${Util.getSpmCode().b}`) || false
                this.scrollInit()
            },
            scrollInit () {
                // 上滑时修改视频播放框的高度
                $(window).on('scroll', Util.throttle((e) => {
                    let scrollTop = $(e.target).scrollTop()
                    this.isScrollTop = scrollTop < 10 && !this.isLayerShow
                }, 200));
            },
            changeMoreNavStatus(obj) {
                const { status,type } = obj
                this.showMoreNav = status
                switch (type) {
                    case "allnav":
                        this.getAllNavComps()
                    break;
      }
            },
            clickSohuBar () {
                if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                    window.sohuSpm.sendAction({
                        acode: 8837
                    });
                }
                window.history.back()
            },
            getAllNavComps () {
                Promise.all([
                    import (/* webpackChunkName: "dynamic4navLayerjs" */ 'common-components/lib/navLayer/index.js'),
                    import (/* webpackChunkName: "dynamic4navLayercss" */ 'common-components/lib/navLayer/index.css')
                ]).then(( [NavLayer] ) => {
                    var NavLayerComp = NavLayer.default
                    Vue.component("nav-layer", {
                        extends:NavLayerComp,
                        props: {
                            config: {
                                type: Object,
                                default: ""
                            }
                        }
                    });
                    this.isLayerShow = true
                    this.showDot = false
                    if (!this.isNavClicked) {
                        LocalStorageUtil.setItem(`navClicked_${Util.getSpmCode().b}`, true)
                        this.isNavClicked  = true
                    }
                })
                
            },
            closeLayer(){
                this.isLayerShow = false
            },
            /** 获取天气 */
            weatherApiFetch () {
                let params = {}
                let storage = ''
                // 获取天气页用户操作的当前地区信息。
                try {
                    storage = JSON.parse(Cookie.get(this.weatherKey))
                } catch(err) {
                    console.log(err)
                }
                if (storage) {
                    this.weatherStationId = storage.stationId
                }
                $.ajax({
                    url: weatherApi,
                    type: 'GET',
                    data: {
                        stationId: this.weatherStationId
                    },
                    dataType: 'json',
                    success: (res) => {
                        if (res && res.code == 200 && res.data ) {
                            this.formatWeatherData(res.data)
                        }
                    },
                    error: () => {
                    }
                })
            },
            formatWeatherData (data) {
                let weatherInfo = data.currentWeatherInfo
                if (this.weatherStationId) {
                    this.weatherLink = `${this.weatherLink}?id=${this.weatherStationId}`;
                }
                this.weatherData = {
                    city: data.currentWeatherInfo.city,
                    weather: data.currentWeatherInfo.weather,
                    temperature: data.currentWeatherInfo.temperature + '°',
                    url: this.weatherLink
                }
            },
            navMapFetch(){
                try {
                    const idsMap = getOdinResourceIdMap('allNavMap')
                    const spmObj = window?.sohuSpm?.getCodes()
                    const promiseList = []
                    idsMap.forEach((item)=>{
                        const params = {
                            tplCompKey: item?.tplCompKey,
                            adInfo: item.adInfo,
                            spmCCode: item.spmCCode,
                            resourceId: item.resourceId,
                            content: {
                                page: 1,
                                size: 30,
                                productId: item.productId,
                                productType: item.productType,
                                spm: `${spmObj?.a}.${spmObj?.b}.${item?.spmCCode}`
                            }
                        }
                        promiseList.push(getOdinData(params))
                    })
                    Promise.all(promiseList).then((res)=>{
                        res.forEach((item,index)=>{
                            this.navMap[idsMap?.[index]?.tplCompKey] = item?.list || []
                        })
                    })
                } catch (error) {
                    console.log(error,'全站导航')
                }
            },
            isObject(object) {
                return object != null && typeof object === "object";
            },
            deepEqual(object1, object2) {
                const keys1 = Object.keys(object1);
                const keys2 = Object.keys(object2);

                if (keys1.length !== keys2.length) {
                    return false;
                }

                for (const key of keys1) {
                    const val1 = object1[key];
                    const val2 = object2[key];
                    const areObjects = this.isObject(val1) && this.isObject(val2);
                    if (
                    (areObjects && !this.deepEqual(val1, val2)) ||
                    (!areObjects && val1 !== val2)
                    ) {
                        return false;
                    }
                }
                return true;
            },
            hasNavChanged(){ // 检测导航是否发生变化
                if(LocalStorageUtil.getItem('navMap')){ // 24小时内发生变化展示红点
                    let previousNavMap = LocalStorageUtil.getItem('navMap')
                    return !this.deepEqual(this.navMap,previousNavMap)
                }
                else return false
            },
            cleanData(dirtData){
                if(Array.isArray(dirtData)){
                    let cleanData = dirtData.map(item=>{
                        let tempItem = {}
                        for(const [key, value] of Object.entries(item)){
                            if(value){
                                tempItem[key] = value
                            }
                        }
                        return tempItem
                    })
                    return cleanData
                }else return dirtData
            },
        },
        watch: {
            isScrollTop (val) {
                if (!val) {
                    // 由于动画推广会有400ms的延迟，页面渲染会延迟
                    setTimeout(() => {
                        this.isShowIcon = true
                    }, 400);
                } else {
                    this.isShowIcon = false
                }
            }
        }
    }
</script>
<style lang="less" scoped>
.top-header {
    display: flex;
    align-items: center;
    position: fixed;
    height: 88px; /*px*/
    width: 100%;
    left: 0;
    top: 0;
    background: #FFFFFF;
    z-index: 990;
    box-sizing: border-box;
    padding: 0px 24px;

    .divide-line{
        margin: 0px 16px;
        width: 1px;
        height: 24px;
        background: #CCCCCC;
    }
    .navbar-icon {
        position: absolute;
        display: flex;
        align-items: center;
        right: 24px;
        .icon-ic_unfold {
            width: 40px;
            height: 40px;
            background: url("//statics.itc.cn/WAP_base/icon_more_empty6@2x.png") center center no-repeat;
            background-size: contain;
        }
        .wather-sec {
            display: block;
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #111111;
            line-height: 40px;
        }
        .weather-text{
            color: #111111;
        }
        .dot {
            position: absolute;
            top: 0px;
            right: 0px;
            width: 12px;/* px */
            height: 12px; /* px */
            border: none;
            border-radius: 100px;
            background-color: #fc4b4b;
            &.show {
                display: block;
            }
        }
    }
    .header__l {
        display: flex;
        flex: 1;
        align-items: center;
        .back-home {
            display: flex;
            align-items: center;
            height: 88px;/* px */
            line-height: 88px; /* px */
            .back {
                width: 40px;
                height: 40px;
                display: inline-block;
                background: url('../../less/images/icon_pre@2x.png') center center no-repeat;
                background-size: contain;
            }
            .sohu {
                display: block;
                width: 40px; /*px*/
                height: 40px; /*px*/
                margin-right: 8px; /*px*/
                background: url("../../less/images/logo.png") center center no-repeat;
                background-size: contain;
            }
            .sohu-font {
                height: 40px;
                font-size: 28px; /*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
            }
        }
    }

    .visible {
        visibility: visible
    }
    .hidden {
        visibility: hidden
    }
    .promotion-box {
        height: 88px; /* px */
        flex: 1;
    }
}
.bottom-shadow{
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06), 0px 8px 20px -4px rgba(0,0,0,0.07);
}
</style>


